import { Component, EventEmitter, Input, Output, DoCheck } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';

@Component({
  selector: 'ready-to-complete',
  styles: [require('../org-vdc.wizard.scss')],
  template: require('./ready-to-complete.html'),
    providers: [
      TranslateService
  ]
})
export class ReadyToComplete {
  @Input() stepData: Object;
  private orgList: JSON;
  private isTranslationready: boolean = true;

 constructor(private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }
  getSDDCPool() {
    if (this.stepData[2] && this.stepData[2].allocModel) {
        let str = this.stepData[2].allocModel;
        return (str === 'PAYASYOUGO')
        ? this.translate.instant('createOrgVdc.allocModel.PAYASYOUGO')
        : this.translate.instant('createOrgVdc.allocModel.RESERVATIONPOOL');
    }
  }

  getIopsEnabled(iops: boolean) {
      return (iops)
        ? this.translate.instant('createOrgVdc.wizard.yes')
        : this.translate.instant('createOrgVdc.wizard.no');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/org-vdc-wizard/steps/ready-to-complete.component.ts